import { CommentAuthor } from './CommentAuthor';
import { Comment as CommentBase } from '@ant-design/compatible';
import { coreActions } from '@sonar-software/sonar-core';
import { CurrentUserAvatar } from '@ui/header';
import { Editor } from '@ui/Editor';
import { PLACEHOLDERS_COPY } from '@sonar-software/sonar-ts-constants';
import { TaggedUser } from '@sonar-software/sonar-ts-types';
import { useAction } from '@hooks';

import React, { useCallback } from 'react';

export interface NewCommentProps {
	initiativeId: number;
}

export const NewComment: React.FC<NewCommentProps> = ({ initiativeId }) => {
	const save = useAction(coreActions.requestPostCoreInitiativesComments);

	const handleSave = useCallback(
		(body: string, bodyHtml: string, taggedUsers: Array<TaggedUser>) =>
			save({
				body,
				bodyHtml,
				initiativeId,
				taggedUsers
			}),
		[ initiativeId, save ]
	);

	return (
		<CommentBase
			author={ <CommentAuthor isCurrentUser /> }
			avatar={ <CurrentUserAvatar /> }
			className='initiative-comment'
			content={
				<Editor
					bordered
					content=''
					editOnClick
					enableMentions
					isForm
					onSave={ handleSave }
					placeholder={ PLACEHOLDERS_COPY.ADD_A_COMMENT } />
			} />
	);
};
